import {ChangeDetectionStrategy, Component, computed, inject, input, output} from "@angular/core";
import {TranslateService} from "@ngx-translate/core";
import {BzSelectItem} from "@bringoz/ui";
import {THREE_PL_SERVICES_GROUP_STATUSES} from "../../constants/threepl-services.constant";

@Component({
  selector: "app-threepl-services-group-status-select",
  templateUrl: "./threepl-services-group-status-select.html",
  standalone: false,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ThreeplServicesGroupStatusSelectComponent {
  readonly group = input<string>();
  readonly groupChange = output<string>();

  private readonly translate = inject(TranslateService);

  readonly options = computed<BzSelectItem<string>[]>(() => [
    {value: "TOTAL", label: this.translate.instant("Total")},
    ...THREE_PL_SERVICES_GROUP_STATUSES.map((status) => ({value: status, label: this.translate.instant(status)})),
  ]);

  onValueChange(value: string | readonly string[] | null): void {
    this.groupChange.emit(value as string);
  }
}
